import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, useLocation } from 'react-router-dom';

import { DashboardLayout } from '@/components/layouts';

export const AppRoot = () => {
  const location = useLocation();
  const isOrganization = location.pathname.includes('organization');
  return (
    <DashboardLayout type={isOrganization ? 'organization' : 'creator'}>
      <ErrorBoundary
        key={location.pathname}
        fallback={<div>Something went wrong!</div>}
      >
        <Outlet />
      </ErrorBoundary>
    </DashboardLayout>
  );
};
